import { PosterBrand } from '@/types/activation/poster';
import { POSTER_DESIGNS } from './posterDesigns';
import { PosterPageFrame, POSTER_PAGE_W, POSTER_PAGE_H } from './PosterPageFrame';

const pageStyle = { width: POSTER_PAGE_W, height: POSTER_PAGE_H } as const;

/**
 * The full poster pack as a stack of A4 page nodes — one per design. Each
 * page carries `data-poster-page` so the PDF generator can rasterize them in
 * order. Rendered offscreen; never shown in the app tree.
 */
export const PosterDocument = ({ brand }: { brand: PosterBrand }) => (
  <>
    {POSTER_DESIGNS.map((design) => (
      <div key={design.id} data-poster-page style={pageStyle}>
        <PosterPageFrame brand={brand} design={design} />
      </div>
    ))}
  </>
);
